export const OhsActionColorRed = '#ec0000';
export const OhsActionColorRedOrange = '#ff6b1c';
export const OhsActionColorOrange = '#fbb309';
export const OhsActionColorYellow = '#ffe001';
export const OhsActionColorLightGreen = '#00c545';
export const OhsActionColorBlue = '#0081d3';
export const OhsActionColorTeal = '#00bbaf';
export const OhsActionColorGreen = '#35C545 ';
export const OhsActionColorGrey = '#e0e1e2';
